import { setSpecificMessage, maxSize } from "valibot";
setSpecificMessage(
  maxSize,
  (issue) => `Taille invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);